<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center pb-5">
            <div class="col-matrix">
                <h6 v-if="sectionBlock.sectionTitle" class="text-uppercase text-weight-semibold">{{sectionBlock.sectionTitle}}</h6>

                <ul
                    class="nav nav-tabs d-flex"
                    id="tabs-personnel"
                    role="tablist"
                >
                    <li
                        v-for="(tab, tabIndex) in sectionBlock.sectionTabs"
                        :key="'tab-personnel-' + tabIndex + '-' + indexMatrix"
                        class="nav-item"
                    >
                        <button
                            class="nav-link font-size-h4"
                            :class="tabIndex == 0 ? 'active' : ''"
                            :id="'tab-' + tabIndex + '-' + indexMatrix"
                            data-bs-toggle="tab"
                            :data-bs-target="tab.tabAncre ? '#' + tab.tabAncre : '#tab-content-' + tabIndex + '-' + indexMatrix"
                            type="button"
                            role="tab"
                            :aria-controls="'tab-content-' + tabIndex + '-' + indexMatrix"
                            aria-selected="true"
                        >
                            {{tab.tabTitle}}
                        </button>
                    </li>
                </ul>

                <div
                    class="tab-content"
                    id="myTabContent"
                >
                    <div
                        v-for="(tab, tabIndex) in sectionBlock.sectionTabs"
                        :key="'tab-content-' + tabIndex + '-' + indexMatrix"
                        class="tab-pane fade"
                        :class="tabIndex == 0 ? 'show active' : ''"
                        :id="tab.tabAncre ? '' + tab.tabAncre : 'tab-content-' + tabIndex + '-' + indexMatrix"
                        role="tabpanel"
                        :aria-labelledby="'tab-content-' + tabIndex + '-' + indexMatrix"
                        tabindex="0"
                    >
                        <PersonnelTabContent
                            :tabContent="tab"
                            :indexMatrix="indexMatrix"
                        />

                        <PersonnelTabContentMobile
                            :tabContent="tab"
                            :indexMatrix="indexMatrix"
                            :tabIndex="tabIndex"
                        />

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

import PersonnelTabContent from '@/components/Parts/PersonnelTabContent'
import PersonnelTabContentMobile from '@/components/Parts/PersonnelTabContentMobile'

// Import bootstrap tabs & accordions
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/collapse'

export default {
    name: 'sectionPersonnel',
    components: {
        PersonnelTabContent,
        PersonnelTabContentMobile,
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
        indexMatrix:{
            type: Number,
            required: false,
        },
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        removeAccents(text) {
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        },
    },
    // On loaded...
    mounted() {
        const cards = document.querySelectorAll(".personnel-member-card.click-effect");

        Array.from(cards).forEach((card) => {
          card.addEventListener("click", () => {

               if( !card.classList.contains('active') ){
                   card.classList.add('active')
               }else{
                   card.classList.remove('active')
               }
          });
        });
    },
}
</script>
